import SurveyForm from "../components/SurveyForm";

const EditCustomSurveyPage = () => <SurveyForm mode="custom" />;

export default EditCustomSurveyPage;
